import { mainSiteUrl } from "@/mocks/categories";

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20fashion%20editorial%20scene%20with%20premium%20luxury%20products%20arranged%20on%20dark%20marble%20surface%2C%20warm%20amber%20accent%20lighting%20from%20above%2C%20luxury%20shopping%20atmosphere%20with%20sneakers%20bags%20and%20accessories%2C%20rich%20deep%20shadows%20and%20dramatic%20warm%20contrast%2C%20editorial%20product%20photography%20with%20sophisticated%20dark%20background&width=1800&height=900&seq=hero-basetao-main&orientation=landscape&nocache=true"
          alt="BaseTao Spreadsheet Guide"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Strong dark overlay for readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-16">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-400"></span>
          <span className="text-xs font-medium text-background-50/90">Updated August 2026</span>
        </div>

        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
          Master BaseTao Spreadsheet:
          <br />
          <span className="text-primary-300">The Complete Guide</span> For Smarter Product Research
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Everything you need to know about BaseTao Spreadsheet including reviews, shipping costs, warehouse management, discount codes, tutorials, and expert comparisons — all in one place.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="#guides"
            className="px-7 py-3 bg-background-50 text-foreground-900 font-semibold rounded-lg hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap text-sm"
          >
            Explore Guides
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap text-sm"
          >
            Visit Main Website
            <i className="ri-external-link-line ml-2"></i>
          </a>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-6">
          {[
            { icon: "ri-check-double-line", text: "Updated 2026 Information" },
            { icon: "ri-file-list-3-line", text: "Complete Spreadsheet Guides" },
            { icon: "ri-scales-3-line", text: "Real Comparison Data" },
            { icon: "ri-shield-check-line", text: "Security Focused" },
          ].map((badge) => (
            <div
              key={badge.text}
              className="flex items-center gap-2 text-background-50/70 text-xs font-medium"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${badge.icon} text-accent-400`}></i>
              </span>
              {badge.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}